import styled from 'styled-components'
import Box from '.'

export default styled(Box)`
  background-color: black;
  padding: 0;

  &:hover::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
